<script>
import { mapGetters, mapState } from 'vuex';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'PricesPushDataTable',
  mixins: [
    dateMixin,
  ],
  data() {
    return {
      headers: [
        { text: 'Product', value: 'product', sortable: false },
        { text: 'Date', value: 'date', sortable: false },
        { text: 'Rate amount', value: 'rateAmount', sortable: false },
        { text: 'Min. stay', value: 'minStay', sortable: false },
        { text: 'Max. stay', value: 'maxStay', sortable: false },
        { text: 'Master', value: 'masterStatus', sortable: false },
        { text: 'Arrival', value: 'arrivalStatus', sortable: false },
        { text: 'Departure', value: 'departureStatus', sortable: false },
        { text: 'Booking limit', value: 'Booking limit', sortable: false },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Updated at', value: 'updatedAt', sortable: false },
      ],
    };
  },
  methods: {
    getProductName(id) {
      const productName = this.channelProducts.items.find(obj => obj.id === id);
      return productName ? productName.tbName : 'None';
    },
  },
  computed: {
    ...mapState({
      prices: state => state.prices.prices,
      channelProducts: state => state.prices.channelProducts,
      list: state => state.prices.list,
      pushPrices: state => state.prices.pushPrices,
    }),
    ...mapGetters({
      pushPrices: 'prices/getPushPrices',
    }),
    getStatusMessage() {
      if (this.list.error) {
        return this.list.errorMessage;
      }
      return !this.list.noContent
        ? 'Search for prices by using the filter'
        : 'No content were found with that filter';
    },
  },
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="pushPrices"
    :loading="list.loading"
    class="elevation-1"
    hide-actions
  >
    <template v-slot:no-data>
      <tr>
        <td v-if="!list.loading" :colspan="headers.length" class="text-xs-center">
          {{ getStatusMessage }}
        </td>
        <td v-if="list.loading" :colspan="headers.length" class="text-xs-center">
          Searching...
        </td>
      </tr>
    </template>
    <template v-if="!list.loading" v-slot:items="price">
      <td>{{ getProductName(price.item.xmlChannelProductId) }}</td>
      <td>{{ formatDateSpecific(price.item.date, 'DD-MM-YYYY', 'No date') }}</td>
      <td>{{ price.item.rateAmount }}</td>
      <td>{{ price.item.minStay }}</td>
      <td>{{ price.item.maxStay }}</td>
      <td>{{ price.item.masterStatus }}</td>
      <td>{{ price.item.arrivalStatus }}</td>
      <td>{{ price.item.departureStatus }}</td>
      <td>{{ price.item.bookingLimit }}</td>
      <td>{{ formatDate(price.item.createdAt, 'No date') }}</td>
      <td>{{ formatDate(price.item.updatedAt, 'No date') }}</td>
      <td>
        <v-menu
          left
          offset-x
          open-on-hover
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              :color="price.item.status.type"
              v-on="on"
              text-color="white"
            >
              {{ price.item.status.label }}
            </v-chip>
          </template>
          <v-card class="">
            <v-card-title primary-title>
              <div>
                <h5 class="headline mb-0">Status</h5>
                <div v-if="price.item.status.warnings.length">
                  <h4 style="font-weight: bold"> Warnings: </h4>
                  <ul v-for="msg in price.item.status.warnings" :key="msg">
                    <li v-html="msg"/>
                  </ul>
                </div>
                <div v-if="price.item.status.errors.length">
                  <h4 style="font-weight: bold"> Errors: </h4>
                  <ul v-for="msg in price.item.status.errors" :key="msg">
                    <li v-html="msg"/>
                  </ul>
                </div>
                <div
                  v-if="!price.item.status.errors.length &&
                  !price.item.status.warnings.length"
                >
                  <p style="font-weight: bold">OK</p>
                </div>
              </div>
            </v-card-title>
          </v-card>

        </v-menu>
      </td>
    </template>
  </v-data-table>
</template>



// WEBPACK FOOTER //
// src/components/prices/PricesPushDataTable.vue